import * as React from 'react';

import { closeChatModal } from '../../actions/chatModal';
import { ChatModal } from '../../components/ChatModal';
import { selectRecommendationById } from '../../selectors/recommendations/selectRecommendationById';
import { useSelector, useDispatch } from 'react-redux';
import { selectChatState } from '../../selectors/chat/selectChatState';

export const ChatModalContainer = () => {
  const dispatch = useDispatch();

  const { offerId, isOpen, gaLabel, defaultMessage } = useSelector(selectChatState);
  const offer = useSelector(selectRecommendationById(offerId));

  const onClose = React.useCallback(() => dispatch(closeChatModal()), [dispatch]);
  const onOpen = React.useCallback(() => {
    // метод заглушка, потом тут будет вызов аналитики
    // oxlint-disable-next-line no-console
    console.log('CHAT OPEN');
  }, []);

  return (
    <ChatModal
      defaultMessage={defaultMessage}
      gaLabel={gaLabel}
      onOpen={onOpen}
      onClose={onClose}
      isOpen={isOpen}
      offer={offer}
    />
  );
};
